/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { TaxIdMappingRule } from '../../models/tax-id-mapping-rule';

export interface TaxIdMappingRulesPost$Params {
  'Active-Tenant-Identifier': string;
      body: TaxIdMappingRule
}

export function taxIdMappingRulesPost(http: HttpClient, rootUrl: string, params: TaxIdMappingRulesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & TaxIdMappingRule>> {
  const rb = new RequestBuilder(rootUrl, taxIdMappingRulesPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      } & TaxIdMappingRule>;
    })
  );
}

taxIdMappingRulesPost.PATH = '/tax-id-mapping-rules';
